import type { FaireProductEntity } from "../../entity_types/product";

export const starter_collection_24: FaireProductEntity = {
  token: "starter_collection_24",
  type: "product",
  name: "Pizza Oil",
  brandName: "Brightland",
  imageUrl: "",
  priceDollars: 29,
  msrpDollars: 58,
  description: "Migrated starter collections product",
  tags: ["starter-collections"],
  freeShipping: true,
  meta: {
    source: "mock",
    importedAt: "2026-03-25T00:00:00.000Z",
    importedBy: "playground-data-migration",
  },
};
